import Joi from 'joi';

export const QuestionDataSchema = Joi.object({
  type: Joi.number().required(),
  question: Joi.string().required(),
  possibleAnswers: Joi.array().required().items(Joi.string()),
  isMandatory: Joi.boolean().required(),
  imageUrl: Joi.string().required(),
  name: Joi.string().required(),
});

export const AnswerDataSchema = Joi.object({
  answerName: Joi.string(),
  selected: Joi.boolean(),
  text: Joi.string(),
});

export const PackageDetailSchema = Joi.object({
  _id: Joi.string(),
  marketing_info: Joi.array().items(
    Joi.object({
      type: Joi.number().required(),
      question: Joi.string().required(),
      possibleAnswers: Joi.array().required().items(Joi.string()),
      isMandatory: Joi.boolean().required(),
      imageUrl: Joi.string().required(),
      name: Joi.string().required(),
    })
  ),
});

export const MarketingInfoAnswerSchema = Joi.object({
  userData: Joi.array().items(
    Joi.object({
      question: Joi.string(),
      answer: Joi.string(),
    })
  ),
});
